import { getRouteApi } from '@tanstack/react-router';

const inventoryRouteApi = getRouteApi('/_authed/inventory/');

export function useInventoryRouteSearch() {
  return inventoryRouteApi.useSearch();
}
